import { useQueryClient } from 'react-query';

import { runMutation } from '../../../../../../../utils/vy-mutation';
import { queryKeys } from '../../../../../../../services/query-key/query-keys';
import { useUpdateContractCustomFieldValue } from '../../../../../../../hooks/requests/use-update-contract-custom-field-value';

type CustomFieldValue = string | number | boolean | null;

export function useContractCustomFieldActions(contractId: string) {
  const updateMutation = useUpdateContractCustomFieldValue(contractId);
  const queryClient = useQueryClient();

  const saveCustomFieldValue = async (
    customFieldDefinitionId: string,
    value: CustomFieldValue,
  ): Promise<void> => {
    const mutationVariables = {
      customFieldDefinitionId,
      updateContractCustomFieldValueRequest: { value },
    };

    await runMutation(
      updateMutation,
      mutationVariables,
      {
        pending: 'Saving custom field...',
        success: 'Custom field saved',
        error: 'Failed to save custom field',
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: queryKeys.contractPage(contractId),
          });
        },
      },
    );
  };

  return { saveCustomFieldValue };
}
